import { REMOVE_EXPIRES_AT, STORE_EXPIRES_AT } from "../store/jwt.module";

const JwtService = {
  store: null,
  init(opts) {
    if (opts.store) {
      this.store = opts.store;
    }
  },

  storeExpiresAt(expiresAt) {
    return this.store.dispatch(STORE_EXPIRES_AT, expiresAt);
  },

  removeExpiresAt() {
    return this.store.dispatch(REMOVE_EXPIRES_AT);
  },

  hasExpiresAt() {
    return !!(this.store && this.store.getters.accessTokenExpiresAt);
  },

  verify() {
    const expiresAt = this.store && this.store.getters.accessTokenExpiresAt;
    if (!expiresAt) {
      console.log("JWT verify: no expiration stored.");
      return false;
    }
    const now = Date.now();
    const expiresAtMs = new Date(expiresAt).getTime();
    if (expiresAtMs <= now) {
      console.log("JWT verify: token has expired.");
      return false;
    }
    return true;
  }
};

export default JwtService;
